import React from 'react'
import { EmptyTipsMessage } from '../../EmptyTipsMessage'

export const Last10Tips = () => {
  return (
    <EmptyTipsMessage card='noContentCard2' />
  )
}
